export const PULSE_EXCEPTION_NAMES = ['PulseException', 'PulseClientException', 'PulseServerException'];
//# sourceMappingURL=constants.js.map